import React, { useState, useEffect, useContext } from "react";
import { Box, Typography, Grid, Divider } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ArrowForwardIosOutlined } from "@mui/icons-material";
import ServiceTrainer1 from "../../assets/showcases/trainer/service1.jpg";
import Service4 from "../../assets/showcases/salon/service3.jpeg";
import ServiceBarber4 from "../../assets/showcases/barber/service4.jpg";
import { CreatorContext } from "../../context/CreatorContext";

const ShowcaseServicesOptions = ({
	sector,
	service,
	backgroundColor,
	showCard,
	showImage,
	showTitle,
}) => {
	const { t } = useTranslation();
	const [content, setContent] = useState(null);
	const { creator } = useContext(CreatorContext);

	useEffect(() => {
		const loadContent = () => {
			switch (sector) {
				case "barber":
					return {
						service: t("homeServices.haircut"),
						image: ServiceBarber4,
						options: [
							{
								options: [
									{
										name: t("homeServices.basicHaircut"),
										duration: t("homeServices.duration30Minutes"),
										price: "€15.00",
									},
									{
										name: t("homeServices.haircutAndWash"),
										duration: t("homeServices.duration45Minutes"),
										price: "€25.00",
									},
									{
										name: t("homeServices.premiumHaircut"),
										duration: t("homeServices.duration60Minutes"),
										price: "€35.00",
									},
								],
							},
						],
					};

				case "salon":
					return {
						service: t("homeServices.manicure"),
						image: Service4,
						options: [
							{
								options: [
									{
										name: t("homeServices.shellacManicure"),
										duration: t("homeServices.duration45Minutes"),
										price: "€24.00",
									},
									{
										name: t("homeServices.classicManicure"),
										duration: t("homeServices.duration30Minutes"),
										price: "€12.00",
									},
									{
										name: t("homeServices.expressManicure"),
										duration: t("homeServices.duration15Minutes"),
										price: "€10.00",
									},
								],
							},
						],
					};

				case "trainer":
					return {
						service: t("homeServices.personalTraining"),
						image: ServiceTrainer1,
						options: [
							{
								options: [
									{
										name: t("homeServices.individualSession"),
										duration: t("homeServices.duration60Minutes"),
										price: "€50.00",
									},
									{
										name: t("homeServices.groupSession"),
										duration: t("homeServices.duration90Minutes"),
										price: "€30.00 per person",
									},
									{
										name: t("homeServices.onlineSession"),
										duration: t("homeServices.duration60Minutes"),
										price: "€30.00",
									},
								],
							},
						],
					};

				default:
					return {};
			}
		};

		setContent(loadContent());
	}, [sector, t]);

	const getTextColorBasedOnBackground = (bgColor) => {
		const r = parseInt(bgColor.substring(1, 3), 16);
		const g = parseInt(bgColor.substring(3, 5), 16);
		const b = parseInt(bgColor.substring(5, 7), 16);
		const brightness = (r * 299 + g * 587 + b * 114) / 1000;
		return brightness > 128 ? "#000000" : "#FFF";
	};

	return (
		<Box
			sx={{
				position: "relative",
				"& *": {
					fontFamily: creator.fontFamilyCap + "!important",
				},
			}}
		>
			{content && showImage && (
				<img
					src={content.image}
					alt={content.service}
					style={{ width: "100%", height: "auto" }}
				/>
			)}
			{content && showTitle && (
				<Typography
					variant="body1"
					sx={{ fontSize: 11, marginTop: showImage ? 0 : 1, marginLeft: 1 }}
				>
					{content.service}
				</Typography>
			)}
			{content && service && service === "serviceDetail1" && (
				<Box sx={{ padding: 1, paddingTop: showTitle ? 0.5 : 1 }}>
					{content.options.map((option, index) => (
						<Box key={index}>
							{option.options.map((detail, idx) => (
								<Box key={idx}>
									<Box
										sx={{
											display: "flex",
											justifyContent: "space-between",
											alignItems: "center",
											padding: showCard ? "8px" : "8px 0",
											backgroundColor: showCard ? backgroundColor : "inherit",
											marginBottom: showCard ? 1 : 0,
											borderRadius: showCard ? 2 : 0,
											color: showCard
												? getTextColorBasedOnBackground(backgroundColor)
												: "inherit",
										}}
									>
										<Box>
											<Typography variant="body1" sx={{ fontSize: 8 }}>
												{detail.name}
											</Typography>
											<Typography variant="body2" sx={{ fontSize: 8 }}>
												{detail.duration}
											</Typography>
										</Box>
										<Typography
											variant="body1"
											sx={{ fontWeight: "bold", fontSize: 8 }}
										>
											{detail.price}
										</Typography>
									</Box>
									{idx < option.options.length - 1 && !showCard && <Divider />}
								</Box>
							))}
						</Box>
					))}
				</Box>
			)}
			{content && service && service === "serviceDetail2" && (
				<Box sx={{ padding: 1, paddingTop: showTitle ? 0.5 : 1 }}>
					{content.options[0].options.map((option, index) => (
						<Box
							key={index}
							sx={{
								marginBottom: 1,
								paddingLeft: 0.5,
								paddingRight: 0.5,
								backgroundColor: showCard ? backgroundColor : "inherit",
								borderRadius: showCard ? 2 : 0,
							}}
						>
							<Box
								sx={{
									display: "flex",
									justifyContent: "space-between",
									alignItems: "center",
									padding: "8px 0",
									marginBottom: showCard ? 1 : 0,
									color: showCard
										? getTextColorBasedOnBackground(backgroundColor)
										: "inherit",
								}}
							>
								<Box>
									<Typography variant="body2" sx={{ fontSize: 8 }}>
										{option.duration}
									</Typography>
									<Typography
										variant="body1"
										sx={{ fontSize: 10, fontWeight: "bold" }}
									>
										{option.name}
									</Typography>
									<Typography variant="body2" sx={{ fontSize: 8 }}>
										{option.price}
									</Typography>
								</Box>
								<ArrowForwardIosOutlined sx={{ fontSize: 8 }} />
							</Box>
						</Box>
					))}
				</Box>
			)}

			{content && service && service === "serviceDetail3" && (
				<Box sx={{ padding: 1, paddingTop: showTitle ? 0.5 : 1 }}>
					{content.options[0].options.map((option, index) => (
						<Box key={index} sx={{}}>
							<Box
								sx={{
									display: "flex",
									justifyContent: "space-between",
									alignItems: "center",
									padding: showCard ? "10px" : "10px 0",
									marginBottom: showCard ? 1 : 0,
									color: showCard
										? getTextColorBasedOnBackground(backgroundColor)
										: "inherit",
									backgroundColor: showCard ? backgroundColor : "inherit",
									borderRadius: showCard ? 2 : 0,
								}}
							>
								<Box>
									<Typography
										variant="body1"
										sx={{ fontSize: 8, fontWeight: "bold" }}
									>
										{option.name}
									</Typography>
									<Typography variant="body2" sx={{ fontSize: 8 }}>
										{option.duration}
									</Typography>
									<Typography variant="body2" sx={{ fontSize: 8 }}>
										{option.price}
									</Typography>
								</Box>
								<ArrowForwardIosOutlined
									sx={{ fontSize: 8, color: "text.secondary" }}
								/>
							</Box>
							{!showCard && <Divider />}
						</Box>
					))}
				</Box>
			)}

			{content && service && service === "serviceDetail4" && (
				<Box sx={{ padding: 1, paddingTop: showTitle ? 0.5 : 1 }}>
					<Grid container>
						{content.options[0].options.map((option, index) => (
							<Grid item xs={6} sm={6} key={index}>
								<Box key={index} sx={{ marginBottom: 1 }}>
									<Box
										sx={{
											paddingLeft: 0.5,
											paddingRight: 0.5,
										}}
									>
										<Box
											sx={{
												display: "flex",
												justifyContent: "space-between",
												alignItems: "center",
												padding: showCard ? "10px" : "10px 0",
												marginBottom: showCard ? 1 : 0,
												color: showCard
													? getTextColorBasedOnBackground(backgroundColor)
													: "inherit",
												backgroundColor: showCard ? backgroundColor : "inherit",
												borderRadius: showCard ? 2 : 0,
											}}
										>
											<Box>
												<Typography
													variant="body1"
													sx={{ fontSize: 8, fontWeight: "bold" }}
												>
													{option.name}
												</Typography>
												<Typography variant="body2" sx={{ fontSize: 8 }}>
													{option.duration}
												</Typography>
												<Typography variant="body2" sx={{ fontSize: 8 }}>
													{option.price}
												</Typography>
											</Box>
										</Box>
									</Box>
								</Box>
							</Grid>
						))}
					</Grid>
				</Box>
			)}
		</Box>
	);
};

export default ShowcaseServicesOptions;
